import { computed } from "nanostores";

import { getWorkflows, SortDirection } from "../api";
import { createApiStore } from "./api-store.ts";
import { $router } from "./router.ts";

export const $workflowsByGraphID = createApiStore(getWorkflows, {
  mapToOptions: ([id]) => ({
    query: {
      graphId: id,
      sortDirection: SortDirection.DESC,
    },
  }),
  params: [
    computed($router, (router) =>
      router?.route === "graph" ? router.params.id : null,
    ),
  ],
  storeKey: "workflows",
});
